module.exports = __webpack_public_path__ + "img/payment_mb_07.01a90da3.png";